const headPrices = {
	'SX 960 50-9': 1487,
	'SX 960 51-9': 1487,
	'SX 960 52-9': 1487,
	'SX 960 53-9': 1564,
	'SX 960 54-9': 1487,
	'SX 960 55-9': 1487,
	'SX 960 40-9': 1487,
	'SX 960 41-9': 1487,
	'SX 960 42-9': 1487,
	'SX 960 43-9': 1564,
	'SX 960 44-9': 1487,
	'SX 960 45-9': 1487,
	'SX 960 10-9': 1487,
	'SX 960 11-9': 1487,
	'SX 960 12-9': 1487,
	'SX 960 13-9': 1564,
	'SX 960 14-9': 1487,
	'SX 960 15-9': 1487,
	'SX 960 20-9': 1487,
	'SX 960 21-9': 1487,
	'SX 960 22-9': 1487,
	'SX 960 23-9': 1564,
	'SX 960 24-9': 1487,
	'SX 960 25-9': 1487,
	'SX 960 30-9': 2449,
	'SX 960 31-9': 2449,
	'SX 960 32-9': 2449,
	'SX 960 51-9/GOLD': 1569,
	'SX 960 41-9/GOLD': 1569,
	'SX 961 50-9': 1160,
	'SX 961 51-9': 1160,
	'SX 961 52-9': 1160,
	'SX 961 53-9': 1237,
	'SX 961 54-9': 1160,
	'SX 961 55-9': 1160,
	'SX 961 40-9': 1160,
	'SX 961 41-9': 1160,
	'SX 961 42-9': 1160,
	'SX 961 43-9': 1237,
	'SX 961 44-9': 1160,
	'SX 961 45-9': 1160,
	'SX 961 10-9': 1160,
	'SX 961 11-9': 1160,
	'SX 961 12-9': 1160,
	'SX 961 13-9': 1237,
	'SX 961 14-9': 1160,
	'SX 961 15-9': 1160,
	'SX 961 20-9': 1160,
	'SX 961 21-9': 1160,
	'SX 961 22-9': 1160,
	'SX 961 23-9': 1237,
	'SX 961 24-9': 1160,
	'SX 961 25-9': 1160,
	'SX 961 30-9': 2002,
	'SX 961 31-9': 2002,
	'SX 961 32-9': 2002,
	'SX 961 51-9/GOLD': 1227,
	'SX 961 41-9/GOLD': 1227,
	'SX 962 50-9': 654,
	'SX 962 51-9': 654,
	'SX 962 52-9': 654,
	'SX 962 53-9': 731,
	'SX 962 54-9': 654,
	'SX 962 55-9': 654,
	'SX 962 40-9': 654,
	'SX 962 41-9': 654,
	'SX 962 42-9': 654,
	'SX 962 43-9': 731,
	'SX 962 44-9': 654,
	'SX 962 45-9': 654,
	'SX 962 10-9': 654,
	'SX 962 11-9': 654,
	'SX 962 12-9': 654,
	'SX 962 13-9': 731,
	'SX 962 14-9': 654,
	'SX 962 15-9': 654,
	'SX 962 20-9': 654,
	'SX 962 21-9': 654,
	'SX 962 22-9': 654,
	'SX 962 23-9': 731,
	'SX 962 24-9': 654,
	'SX 962 25-9': 654,
	'SX 962 51-9/GOLD': 695,
	'SX 962 41-9/GOLD': 695,
};
const cltPrices = {
	None: 0,
	Yes: 20,
};
const zhagaPrices = {
	None: 0,
	Top: 270,
	Bottom: 270,
	TopBottom: 115,
};
const protectionPrices = {
	Class1: 89,
	Class2: 0,
};
const controlPrices = {
	NoDim: 0,
	AmpDim: 20,
	Dyn: 20,
	Dali: 20,
	HNS: 20,
	DaliPlusAmpDim: 40,
	DaliPlusDyn: 40,
	CircularProfile: 165,
};
const accessoryPrices = {
	OlivioGrande: {
		None: 0,
		Cap: 282,
		ConcentricLouver: 107,
		ConcentricLouverCap: 107 + 282,
		HoneycombLouver: 107,
		HoneycombLouverCap: 107 + 282,
		LinearSpreadLens: 95,
		LinearSpreadLensCap: 95 + 282,
		PrismaticDiffuser: 95,
		PrismaticDiffuserCap: 95 + 282
	},
	OlivioMedio: {
		None: 0,
		Cap: 282,
		ConcentricLouver: 100,
		ConcentricLouverCap: 100 + 282,
		HoneycombLouver: 100,
		HoneycombLouverCap: 100 + 282,
		LinearSpreadLens: 74,
		LinearSpreadLensCap: 74 + 282,
		PrismaticDiffuser: 74,
		PrismaticDiffuserCap: 74 + 282
	},
	OlivioPiccolo: {
		None: 0,
		Cap:  282,
		ConcentricLouver: 90,
		ConcentricLouverCap: 90 + 282,
		HoneycombLouver: 90,
		HoneycombLouverCap: 90 + 282,
		LinearSpreadLens: 72,
		LinearSpreadLensCap: 72 + 282,
		PrismaticDiffuser: 72,
		PrismaticDiffuserCap: 72 + 282
	},

};

export function getHeadPrice(sx, clt, zhaga, protection, control, accessory, housingSize) {
	return headPrices[sx] +
		(cltPrices[clt] ?? 0) +
		(zhagaPrices[zhaga] ?? 0) +
		(protectionPrices[protection] ?? 0) +
		(controlPrices[control] ?? 0) +
		(accessoryPrices[housingSize][accessory] ?? 0)
		?? null;
}
